// Admin -> Settings (SettingsPage + IntegrationsPanel), ru
export default {
  title: "Настройки",
  subtitle: "Правила для всей компании · каждое изменение пишется в журнал аудита",
  ownerOnlyTitle: "Менять настройки может только владелец",
  ownerOnlyDesc: "Попросите владельца обновить статусы, правила закрепления, KPI и настройки безопасности.",
  sections: {
    statuses: "Статусы и причины",
    assignment: "Закрепление",
    kpi: "KPI и бонус",
    expenses: "Бюджет",
    security: "Безопасность",
    documents: "Документы",
    problems: "Правила водителей",
    integrations: "Интеграции",
  },
  problems: {
    title: "Проблемные водители",
    formTitle: "Обязательно при сохранении",
    formHint: "Имя обязательно всегда. Эти поля нужно заполнить при создании водителя; старые записи можно редактировать.",
    lostReason: "Причина обязательна при потере водителя",
    lostReasonHint: "Отказ, не заинтересован, ушёл.",
    receiptHint: "Нужен ли чек для расхода, задаётся в разделе",
    subtitle: "Какие водители считаются требующими внимания. Эти же правила работают в фильтре списка, в отметке строки и на главной.",
    requiredTitle: "Обязательные поля профиля",
    requiredHint: "Если хотя бы одно пустое, водитель отмечается как \"профиль не заполнен\".",
    fromStatus: "Требуется начиная с этапа",
    fromStatusHint: "Более ранние этапы не проверяются: у нового лида может быть только имя и телефон.",
    expiringDays: "Документ истекает в течение (дней)",
    expiringHint: "CDL, медкарта и загруженные документы.",
    staleHint: "\"Давно нет контакта\" и \"застрял на этапе\" используют порог {{days}} дн. из раздела",
    fields: { phone: "Телефон", email: "Email", state: "Штат", city: "Город", date_of_birth: "Дата рождения", cdl_class: "Класс CDL", cdl_state: "Штат CDL", cdl_number: "Номер CDL", cdl_expires: "Срок CDL", medical_card_expires: "Срок медкарты", experience_months: "Опыт", driver_type: "Тип водителя", freight_type: "Тип груза", endorsements: "Допуски", equipment: "Техника", home_time: "Домой", desired_pay: "Желаемая оплата", available_from: "Доступен с" },
  },
  saved: "Настройки сохранены",
  savedDesc: "Каждое изменение записано в журнал аудита.",
  conflict: "Настройки изменил кто-то другой. Перезагружено.",
  saveFailed: "Не удалось сохранить настройки.",
  unsaved_one: "{{count}} несохранённое изменение",
  unsaved_few: "{{count}} несохранённых изменения",
  unsaved_many: "{{count}} несохранённых изменений",
  unsaved_other: "{{count}} несохранённых изменения",
  statuses: {
    title: "Статусы",
    subtitle: "Этапы воронки фиксированы: Новый → Связались → Подходит → Документы → Подан → Проверка → Ориентация → Нанят.",
    staleDays: "Карточка «зависла» через (дней)",
    staleDaysHint: "Карточки в воронке краснеют, если водитель задержался на этапе дольше этого срока.",
    rejection: "Причины отказа",
    rejectionDesc: "Обязательно, когда водитель отклонён перевозчиком.",
    lost: "Причины потери",
    lostDesc: "Обязательно для «Не заинтересован».",
    quit: "Причины ухода",
    quitDesc: "Обязательно, когда нанятый водитель уходит.",
    newReason: "Новая причина",
  },
  assignment: {
    title: "Закрепление водителя",
    period: "Срок закрепления",
    days: "дней",
    periodHint: "Водитель остаётся за рекрутером, который добавил его первым.",
    whenEnds: "Когда срок заканчивается",
    extend: "Продлевать автоматически, если была активность за последние {{days}} дней",
    returnToPool: "Вернуть в пул филиала",
    askManager: "Решает менеджер филиала (уведомление)",
    window: "Окно активности (дней)",
    transferHint: "Менеджер может передать водителя раньше (пишется в журнал аудита).",
    duplicates: "Проверка дубликатов",
    phone: "Номер телефона",
    phoneHint: "сравнивается в одном формате (+1 555 010 0142)",
    cdl: "Номер CDL + штат",
    email: "Email",
    onMatch: "Если найдено совпадение",
    blockShowOwner: "Запретить создание и показать текущего владельца",
    allowWarning: "Разрешить с предупреждением",
    blockRecruiters: "Запретить рекрутерам, менеджер и владелец могут добавить после подтверждения",
    always: "Номер телефона и номер CDL — всегда: один номер может быть только у одного активного водителя (запрет независимо от выбора ниже).",
    phoneSecondary: "Второй телефон",
    phoneSecondaryHint: "оба номера сравниваются с обоими номерами других водителей",
    name: "Имя и фамилия",
    nameHint: "только предупреждение: у другого человека может быть такое же имя. У импортированных водителей нет телефона — их находит только эта проверка",
    policyHint: "Касается второго телефона и email. При предупреждении пользователь подтверждает «это другой человек» (пишется в Audit log)."
  },
  kpi: {
    title: "Правило бонуса",
    subtitle: "Бонусы считаются по истории статусов и утверждаются в Бюджет → Бонусы.",
    ruleName: "Название правила",
    currency: "Валюта",
    perHire: "За утверждённый найм",
    monthlyGoal: "Месячная цель по найму на рекрутера",
    monthlyGoalHint: "Показывается в виджете «Цель месяца»; 0 — цель выключена",
    stayed30: "Остался 30 дней",
    stayed60: "Остался 60 дней",
    stayed90: "Остался 90 дней",
    approver: "Кто утверждает бонусы",
    retention: "Проверки удержания (дни)",
    retentionHint: "Через запятую, например 30, 60, 90",
    expiry: "Напоминания о сроках",
    expiryDesc: "Автоматические напоминания до истечения CDL и медкарты.",
    daysBefore: "Дней до истечения",
    daysBeforeHint: "Через запятую, например 30, 7",
  },
  expenses: {
    title: "Категории расходов",
    subtitle: "Используются в Бюджет → Расходы и Деньги → Расход. Комиссия % — необязательно: добавляется при оплате расхода.",
    newCategory: "Новая категория",
    rules: "Правила расходов",
    receipt: "Чек обязателен",
    receiptHint: "Расход без чека нельзя отправить",
    approver: "Кто утверждает расходы",
    alert: "Предупреждение по бюджету (% плана)",
    alertHint: "Владелец получает уведомление, когда филиал превышает это",
    autoLimit: "Лимит без одобрения",
    autoLimitHint: "Расход менеджера до этой суммы одобряется автоматически; 0 — одобрение нужно всегда",
  },
  income: {
    title: "Категории доходов",
    subtitle: "Используются в Деньги → Доход (необязательно). Комиссия % — необязательно: вычитается из поступивших денег.",
    newCategory: "Новая категория",
  },
  security: {
    twofa: "Двухфакторная аутентификация",
    twofaDesc: "Сотрудники с этими ролями должны настроить приложение-аутентификатор, прежде чем начать работу, и не могут его отключить.",
    sessions: "Сессии и вход",
    sessionHours: "Срок сессии (часов)",
    maxAttempts: "Неудачных попыток до блокировки",
    lockMinutes: "Длительность блокировки (минут)",
    applyNext: "Настройки сессии и блокировки применяются при следующем входе.",
    public: "Публичные страницы",
    publicDesc: "этап 3",
    applyForm: "Форма заявки водителя (/apply)",
    portalPhone: "Портал перевозчика показывает телефон водителя",
    companyName: "Название компании",
  },
  list: {
    rateHead: "Комиссия, %",
    rateAria: "Комиссия для {{item}}, %",
    remove: "Удалить {{item}}",
    empty: "Список пуст",
    add: "Добавить",
  },
  integrations: {
    pill: { error: "Ошибка", connected: "Подключено", disabled: "Отключено", notConfigured: "Не настроено" },
    conflict: "Изменено в другом окне. Перезагружено.",
    saveFailed: "Не удалось сохранить.",
    notConfigured: "Verifix не настроен",
    notConfiguredDesc: "Сначала укажите VERIFIX_CLIENT_ID / VERIFIX_CLIENT_SECRET в .env и filial_id.",
    done: "{{kind}}: готово",
    failed: "{{kind}}: ошибка",
    requestFailed: "Запрос не выполнен.",
    subtitle: "Филиал: {{filial}} · последняя синхронизация {{when}} · сотрудников: {{n}}",
    clientId: "Client ID",
    clientIdHint: "Client secret задаётся в .env на сервере (никогда не показывается)",
    notSet: "— не задан в .env",
    filialId: "Filial ID",
    filialHint: "Организация Verifix (заголовок filial_id)",
    test: "Проверить соединение",
    syncNow: "Синхронизировать",
    pullSalaries: "Получить зарплаты",
    pushBonuses: "Отправить бонусы",
    enabled: "Включено",
    lastError: "Последняя ошибка",
    whatToSync: "Что синхронизировать",
    syncEmployees: "Сотрудники и подразделения → Пользователи, Филиалы",
    hourly: "ежечасно",
    syncSalaries: "Зарплаты ← Verifix",
    monthlyPro: "ежемесячно, Pro",
    pushBonusesLabel: "Утверждённые бонусы → разовое начисление в Verifix",
    syncAttendance: "Посещаемость → Отчёты",
    daily: "ежедневно",
    lastRun: "Последний запуск",
    ok: "ок",
    runFailed: "ошибка",
    pullTitle: "Получить зарплаты из Verifix",
    pullDesc: "Обновляются только невыплаченные зарплаты.",
    pull: "Получить",
    month: "Месяц",
    mappingSaved: "Сопоставление сохранено",
    mappingFailed: "Не удалось сохранить сопоставление.",
    mapDivision: "Соответствие: подразделение Verifix → филиал",
    mapEmployee: "Сопоставление: сотрудник Verifix → пользователь",
    mapSubtitle: "активных: {{n}} · не сопоставлено: {{unmatched}}",
    hideMatched: "Скрыть сопоставленные",
    showMatched: "Показать сопоставленные",
    afterSync: "Сопоставления появятся после первой синхронизации.",
    nothingSynced: "Пока ничего не синхронизировано. Нажмите «Синхронизировать».",
    allMatched: "Всё сопоставлено.",
    colVerifix: "Verifix",
    colOurs: "У нас",
    colMapTo: "Сопоставить с",
    unmatched: "— Не сопоставлено",
    none: "— нет —",
    branchSuffix: "(филиал)",
    errors: "Ошибки ({{n}})",
    errorsDesc: "каждая синхронизация пишется в журнал аудита",
  },
  google: {
    title: "Аккаунт Google",
    subtitle: "Импорт читает Google Таблицы от имени этого аккаунта · только чтение",
    pill: { connected: "Подключён", reauth: "Нужно переподключить", notConnected: "Не подключён", notConfigured: "Не настроен" },
    notConfiguredDesc: "Для подключения аккаунта Google нужен OAuth-клиент Google. Разработчик создаёт его в Google Cloud и добавляет GOOGLE_OAUTH_CLIENT_ID и GOOGLE_OAUTH_CLIENT_SECRET в .env. Укажите в OAuth-клиенте этот URI перенаправления:",
    redirectUri: "Разрешённый URI перенаправления",
    setupDoc: "Пошаговая настройка: docs/09-ishga-tushirish.md, раздел «Google akkaunt».",
    whatFor: "Подключите аккаунт Google, которому принадлежат таблицы компании или у которого есть к ним доступ. Тогда импорт будет читать таблицы напрямую по ссылке. Система никогда не изменяет ваши таблицы.",
    permission: { profile: "Видеть email и имя аккаунта", sheets: "Читать Google Таблицы (только чтение)" },
    connect: "Подключить аккаунт Google",
    connectFailed: "Не удалось начать подключение Google.",
    connectedBy: "Подключил: {{who}}",
    access: "Доступ",
    sheetsReadOnly: "Google Таблицы, только чтение",
    noSheetsAccess: "Нет доступа к Google Таблицам — переподключите и разрешите",
    lastUsed: "Последнее использование",
    neverUsed: "Ещё не использовался",
    switchAccount: "Подключить другой аккаунт",
    reconnect: "Переподключить",
    disconnect: "Отключить",
    disconnected: "Аккаунт Google отключён",
    disconnectFailed: "Не удалось отключить.",
    disconnectTitle: "Отключить аккаунт Google?",
    disconnectDesc: "Система потеряет доступ к Google Таблицам аккаунта {{email}}. Импорт по ссылке перестанет работать, пока аккаунт Google не будет подключён снова. Уже импортированные данные сохранятся.",
    reauthTitle: "Доступ к Google истёк",
    reauthDesc: "Google отклонил сохранённый доступ (сменили пароль или отозвали доступ). Переподключите аккаунт, чтобы снова читать таблицы.",
    technical: "Технические данные",
    clientId: "Client ID",
    copy: "Копировать",
    copied: "Скопировано",
    copyFailed: "Не удалось скопировать. Выделите текст и скопируйте вручную.",
    result: {
      connected: "Аккаунт Google подключён",
      connectedDesc: "Теперь импорт может читать Google Таблицы по ссылке.",
      cancelled: "Подключение Google отменено.",
      failed: "Аккаунт Google не подключён",
    },
    reason: {
      state: "Запрос на подключение устарел или не совпал. Начните заново с этой страницы.",
      scope: "Доступ к Google Таблицам не разрешён. Подключите снова и не снимайте галочку Google Таблиц.",
      forbidden: "Подключить аккаунт Google может только владелец.",
      denied: "Google отказал в доступе.",
      redirect_uri_mismatch: "URI перенаправления не зарегистрирован в OAuth-клиенте Google. Добавьте URI из блока «Технические данные» ниже в Google Cloud.",
      invalid_client: "Google не принял client ID или secret. Проверьте GOOGLE_OAUTH_CLIENT_ID и GOOGLE_OAUTH_CLIENT_SECRET в .env.",
      invalid_grant: "Код Google устарел. Попробуйте подключить ещё раз.",
      no_refresh_token: "Google не выдал офлайн-доступ. Удалите приложение в аккаунте Google (Безопасность → Сторонние приложения) и подключите снова.",
      network: "Не удалось связаться с Google. Проверьте подключение к интернету и повторите попытку.",
      userinfo: "Не удалось прочитать email аккаунта Google. Повторите попытку.",
      unknown: "Код ошибки: {{code}}",
    },
  },
  payments: {
    title: "Оплаты перевозчиков",
    subtitle: "Деньги, которые перевозчик платит компании за каждого нанятого водителя.",
    dueDays: "Срок после выхода водителя (дней)",
    dueDaysHint: "Применяется к новым наймам; у уже нанятых дата не меняется",
  },
  documents: {
    title: "Типы документов",
    subtitle: "Что рекрутер собирает у водителя. Обязательные типы учитываются для «Отправлен»; у типов со сроком показывается дата действия.",
    name: "Название",
    key: "Ключ",
    required: "Обязательно",
    expires: "Есть срок действия",
    remove: "Убрать {{name}}",
    protectedHint: "CDL и медкарта остаются: к ним привязаны AI-чтение и напоминания о сроках.",
    newType: "Новый тип документа",
    add: "Добавить",
    blockTitle: "Отправка перевозчику",
    block: "Не переводить в «Отправлен», пока не загружены все обязательные документы",
    blockHint: "Выкл: окно смены статуса только предупреждает о недостающих документах.",
    ocrNote: "AI-чтение (Gemini) настраивается в разделе «Интеграции».",
  },
  ocr: {
    title: "AI-чтение документов",
    subtitle: "Gemini читает фото CDL и медкарты и предлагает поля профиля. Ничего не меняется, пока человек не примет.",
    pill: { on: "Вкл", off: "Выкл", notConfigured: "Не настроено" },
    notConfigured: "Ещё не подключено. В .env на сервере: Vertex AI с Application Default Credentials (GEMINI_USE_VERTEX=1, GOOGLE_CLOUD_PROJECT) или ключ платного тарифа AI Studio (GEMINI_API_KEY) — docs/09-ishga-tushirish.md.",
    model: "Модель",
    auth: "Подключение",
    authVertex: "Vertex AI · проект {{project}} (Application Default Credentials)",
    authKey: "API-ключ AI Studio",
    enabled: "Читать загруженные документы автоматически",
    kinds: "Какие типы документов читать",
    month: "В этом месяце",
    monthLine: "{{documents}} прочитано · {{failed}} не удалось · {{input}} вход / {{output}} выход токенов",
    cost: "≈ ${{cost}}",
    costUnknown: "цены этой модели нет в таблице",
    privacy: "Только платный тариф: Google не обучается на платных запросах. SSN никогда не читается; анкета не отправляется.",
    saved: "Настройки AI-чтения сохранены",
  },
  sheets: {
    title: "Копия в Google Таблицах",
    subtitle: "Текущее состояние в виде старой таблицы: Partners, лист Database для каждого филиала и Pipeline",
    pill: { on: "Включено", paused: "Приостановлено", error: "Ошибка", off: "Не подключено" },
    download: "Скачать (.xlsx)",
    notConfiguredDesc: "Для автоматической копии нужен сервисный аккаунт Google. Разработчик настраивает его один раз: docs/09-ishga-tushirish.md, раздел «Google Sheets nusxasi». А пока скачайте файл — он открывается в Excel или в Google Диске.",
    step1: "Создайте пустую таблицу в Google Таблицах.",
    step2: "Откройте к ней доступ (кнопка «Настройки доступа») для этого email с ролью «Редактор»:",
    step3: "Вставьте ссылку на таблицу:",
    link: "Ссылка на таблицу",
    connect: "Подключить",
    firstWrite: "Таблица заполняется в первый раз…",
    connected: "Таблица подключена и заполнена",
    untitled: "Таблица",
    updated: "Обновлено {{when}}",
    notYet: "Ещё не записана",
    connectedBy: "подключил(а): {{who}}",
    syncNow: "Обновить сейчас",
    synced: "Таблица обновлена",
    errorTitle: "Последнее обновление не удалось",
    auto: "Обновлять автоматически",
    autoHint: "в течение 2 минут после изменения",
    rows_one: "{{count}} строка",
    rows_few: "{{count}} строки",
    rows_many: "{{count}} строк",
    rows_other: "{{count}} строки",
    disconnect: "Отключить",
    disconnectTitle: "Отключить таблицу?",
    disconnectDesc: "Платформа перестанет её обновлять. Сама таблица и данные в ней останутся в Google Диске.",
    disconnected: "Таблица отключена",
    oneWay: "Копия в одну сторону: правки в таблице перезаписываются при следующем обновлении. Все, у кого есть доступ к таблице, видят всех водителей — делитесь ею осторожно.",
  },
};
